import Vuex from 'vuex'
import Vue from 'vue'
import { pick } from 'lodash'
import VuexPersistence from 'vuex-persist'

import * as mutations from './mutations'
import * as getters from './getters'
import auth from '../auth'

// Persist targeted state to local storage
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => pick(state, [
    'selectedMemberNumber'
  ])
})

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    selectedMemberNumber: null,
    selectedMember: null
  },
  mutations: {
    [mutations.SET_SELECTED_MEMBER_NUMBER] (_state, payload = null) {
      _state.selectedMemberNumber = payload
    }
  },
  actions: {
  },
  getters: {
    [getters.SELECTED_MEMBER_AUTHORIZATION] (_state) {
      if (!auth.isAuthenticated) return null
      const linkages = auth.userProfile?.members ?? []
      return linkages.find(o => o.memberNumber === _state.selectedMemberNumber)
    },
    [getters.IS_ADMIN_FOR_REGISTRATION] (_state, _getters) {
      return _getters[getters.SELECTED_MEMBER_AUTHORIZATION]?.isAdminForRegistration ?? false
    }
  },
  modules: {
  },
  plugins: [
    vuexLocal.plugin
  ]
})
